import { TestResolver } from "../../models";

export const oneOfTwoFieldsIsRequired: TestResolver = ({
  context,
  validationAdditional,
  value,
  errorMessage,
}) => {
  const siblingFieldName = validationAdditional.siblingName;

  if (!siblingFieldName) {
    return true;
  }

  if (context.parent[siblingFieldName] || value) {
    return true;
  }

  return context.createError({ message: errorMessage });
};
